import React, { memo } from "react";
import PropTypes from "prop-types";

import DataList from "shared/react_components/DataList";
import OptionalDatumCol from "./OptionalDatumCol";

const CustomerDataSection = ({ title, data }) => {
  const sortedData = data.sort((a, b) => (a.friendlyName > b.friendlyName) ? 1 : -1);

  return (
    <section>
      <h2>{title}</h2>
      <DataList className="row">
        {sortedData.map(({ partnerName, friendlyName, value }) => (
          <OptionalDatumCol key={partnerName} label={friendlyName}>
            {value}
          </OptionalDatumCol>
        ))}
      </DataList>
    </section>
  );
};

CustomerDataSection.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      partnerName: PropTypes.string.isRequired,
      friendlyName: PropTypes.string.isRequired,
      value: PropTypes.string
    })
  )
};

CustomerDataSection.defaultProps = {
  data: []
};

export default memo(CustomerDataSection);
